<app-recipes-translation-section
  [sectionOptions]="{
    title: 'RECIPE_TRANSLATION.SECTIONS.TITLES.HEADER',
    icon: 'ic_title',
    lang: lang
  }"
>
  <app-recipes-translation-fields-container>
    <div class="titles-section-div">
      <app-recipes-translation-input-fields
        [fieldsOptions]="{
          label: 'RECIPE_TRANSLATION.SECTIONS.TITLES.TITLE' | translate,
          sourceControl: {
            left: sourceTitlesFg.controls['title']
          },
          targetControl: {
            left: targetTitlesFg.controls['title']
          },
          fieldName: {
            left: 'RECIPE_TRANSLATION.SECTIONS.TITLES.TITLE' | translate
          }
        }"
      >
      </app-recipes-translation-input-fields>
      <app-recipes-translation-input-fields
        *ngIf="domain === COOKEO_DOMAIN"
        [fieldsOptions]="{
          label: 'RECIPE_TRANSLATION.SECTIONS.TITLES.SHORT_TITLE' | translate,
          sourceControl: { left: sourceTitlesFg.controls['shortTitle'] },
          targetControl: { left: targetTitlesFg.controls['shortTitle'] }
        }"
      >
      </app-recipes-translation-input-fields>
      <app-recipes-translation-input-fields
        [fieldsOptions]="{
          label: 'RECIPE_TRANSLATION.SECTIONS.TITLES.SUMMARY' | translate,
          sourceControl: { left: sourceTitlesFg.controls['summary'] },
          targetControl: { left: targetTitlesFg.controls['summary'] }
        }"
      >
      </app-recipes-translation-input-fields>
    </div>
  </app-recipes-translation-fields-container>
</app-recipes-translation-section>
